module.exports = __webpack_public_path__ + "img/CPQ-video.4fba492f.jpg";